import { c as _c } from "react/compiler-runtime";
import { classNames, SkeletonBlock, TableCell, TableRow, TextBodySkeleton, tableRowSizeVariants } from "@opensea/ui-kit";
import { MINT_FEED_TABLE_COLUMN_CLASSNAMES } from "@/components/collection/drops/constants";
export function MintFeedTableRowSkeleton(t0) {
  const $ = _c(30);
  const {
    override
  } = t0;
  let T0;
  let T1;
  let T2;
  let t1;
  let t2;
  let t3;
  if ($[0] !== override?.Skeleton?.className) {
    const {
      image
    } = tableRowSizeVariants({
      size: "md"
    });
    T2 = TableRow;
    t3 = "w-full";
    T1 = TableCell;
    t2 = MINT_FEED_TABLE_COLUMN_CLASSNAMES.item;
    T0 = SkeletonBlock;
    t1 = classNames(image(), "size-8", override?.Skeleton?.className);
    $[0] = override?.Skeleton?.className;
    $[1] = T0;
    $[2] = T1;
    $[3] = T2;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    T0 = $[1];
    T1 = $[2];
    T2 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== T0 || $[8] !== t1) {
    t4 = <T0 className={t1} />;
    $[7] = T0;
    $[8] = t1;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = override?.Skeleton?.className;
  let t6;
  if ($[10] !== t5) {
    t6 = <TextBodySkeleton className={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== T1 || $[13] !== t2 || $[14] !== t4 || $[15] !== t6) {
    t7 = <T1 className={t2}>{t4}{t6}</T1>;
    $[12] = T1;
    $[13] = t2;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = override?.Skeleton?.className;
  let t9;
  if ($[17] !== t8) {
    t9 = <TableCell className={MINT_FEED_TABLE_COLUMN_CLASSNAMES.price}><TextBodySkeleton className={t8} /></TableCell>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = override?.Skeleton?.className;
  let t11;
  if ($[19] !== t10) {
    t11 = <TableCell className={MINT_FEED_TABLE_COLUMN_CLASSNAMES.quantity}><TextBodySkeleton className={t10} /></TableCell>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = override?.Skeleton?.className;
  let t13;
  if ($[21] !== t12) {
    t13 = <TableCell className={MINT_FEED_TABLE_COLUMN_CLASSNAMES.timestamp}><TextBodySkeleton className={t12} /></TableCell>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== T2 || $[24] !== t11 || $[25] !== t13 || $[26] !== t3 || $[27] !== t7 || $[28] !== t9) {
    t14 = <T2 className={t3}>{t7}{t9}{t11}{t13}</T2>;
    $[23] = T2;
    $[24] = t11;
    $[25] = t13;
    $[26] = t3;
    $[27] = t7;
    $[28] = t9;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
}